import {setupI18n} from '>shared/lib/i18n';
import {defaultNS, fallbackLanguage, nameSpaces, resources} from './generated/locales/config';
import {history} from './history';

export default setupI18n(history, resources, fallbackLanguage, nameSpaces, defaultNS);
